import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { TypedTable } from "../../../components/TypedTable";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useDisclosureData } from "../../../hooks/UseDisclosure";
import { ModalPuesto } from "./components/ModalPuesto";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function GestionPuestosPage() {
	return (
		<div id="content" className="content" >
			<title>Almacen | Gestión de puestos</title>
			<Breadcrumb
				sectionTitle="Gestión de subpuestos"
				links={[
					{ label: "Gestión de subpuestos", active: true }
				]}
			/>

			<div className="box-shadow panel-box panel-info">
				<h4><strong>Info</strong></h4>
				Aquí podrá encontrar el listado de los puestos activos en el ERP, y podrá gestionar los subpuestos que contiene cada uno pinchando sobre
				el icono + en la fila correspondiente. Además, se visualizarán los operarios asignados a ese puesto
			</div>

			<TablaPuestos />
		</div>
	);
}

function TablaPuestos() {
	const { data, error, isPending } = UsePuestos();
	const disclosePuesto = useDisclosureData("");

	const openPuesto = disclosePuesto.open;

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Puesto>();

		const accionesPuesto = (puesto: Puesto) => {
			return (
				<button className="main-color btnIcon" onClick={() => openPuesto(puesto.idMaquina)} type="button">
					<i className="fa fa-circle-plus" style={{ fontSize: 25, margin: "0 10px" }} />
				</button>
			);
		};

		const spanOperarios = (operarios: string) => {
			// eslint-disable-next-line react/no-danger -- Viene asi de php y no voy a cambiarlo ahora
			return <span dangerouslySetInnerHTML={{ __html: operarios }} />;
		};

		return [
			columnHelper.accessor("idMaquina", { header: "ID", meta: { className: "dt-center" } }),
			columnHelper.accessor("nombreMaquina", { header: "Puesto", meta: { className: "dt-center" } }),
			columnHelper.accessor("operarios", { header: "Operarios", cell: info => spanOperarios(info.getValue()), meta: { className: "dt-center" } }),

			columnHelper.display({
				id: "acciones",
				header: "",
				cell: (info) => accionesPuesto(info.row.original),
				meta: { className: "dt-center" }
			}),
		];
	}, [openPuesto]);

	if (error) return <QueryError error={error} fallback="Error al cargar los puestos" />;
	if (isPending) return <Loading />;

	return <>
		<TypedTable
			className="dataTable display"
			data={data}
			columns={columns}
		/>

		<ModalPuesto
			show={disclosePuesto.isOpen}
			close={disclosePuesto.close}
			idPuesto={disclosePuesto.data}
		/>
	</>;
}


function UsePuestos() {
	return useQuery<Puesto[]>({
		queryKey: ["puestos"],
		queryFn: () => {
			const url = "/puestos";
			return ComunicacionAjax.sendAjaxRequest<Puesto[]>("GET", url);
		},
	});
}

interface Puesto {
	idMaquina: string;
	nombreMaquina: string,
	operarios: string,
}